import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-biblia-to-export',
  templateUrl: './biblia-to-export.component.html',
  styleUrls: ['./biblia-to-export.component.css']
})
export class BibliaToExportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
